import { jsxs as j, jsx as a } from "react/jsx-runtime";
import { useState as i, useRef as k, useMemo as H, useCallback as b, useEffect as R } from "react";
import { LINE_HEIGHT as z, Container as F, RetractText as G, ReadMore as N, ImgWrapper as V } from "./styles.js";
import { CommentContentRenderer as A } from "../CommentContentRenderer/index.js";
import { getImagesFromContent as B, contentToHtml as I, elementToText as T, clearContent as L, removeBreaklines as S, removeImagesFromContent as D } from "../../services/content/index.js";
import { ImagesList as P } from "../ImagesList/index.js";
import { useTranslation as X } from "../../../../hooks/useTranslation/index.js";
const q = 4, J = z * 16 + q, K = (e) => B(I(e)), Q = (e) => T(
  L(
    S(D(I(e)))
  )
), U = (e) => T(L(S(I(e)))), Y = (e) => {
  const [g, n] = i([]), [d, c] = i(), [o, u] = i();
  return R(() => {
    n(K(e)), c(Q(e)), u(U(e));
  }, [e]), {
    images: g,
    contentWithoutImage: d,
    cleanedContent: o
  };
}, re = ({
  content: e,
  className: g,
  maxLines: n = 2,
  clickoutFunction: d
}) => {
  const { t: c } = X("common"), [o, u] = i(!0), [E, h] = i(!1), m = k(null), {
    images: s,
    contentWithoutImage: l,
    cleanedContent: M
  } = Y(e), p = s.map((t) => t.outerHTML).splice(0, 4).join(""), v = H(
    () => l === "" && s.length >= 1,
    [l, s.length]
  ), r = l === "" && s.length === 1, x = !!(!r && o && p), y = () => {
    if (r)
      return s[0].outerHTML;
    if (!v)
      return o ? l : M;
  }, O = () => {
    u((t) => !t);
  }, W = (t, C) => {
    const _ = J * C;
    return t > _;
  }, f = b(
    ({ current: t }) => {
      if (!t)
        return;
      const C = W(
        t.scrollHeight,
        n
      );
      h(!!(C && !r));
    },
    [r, n]
  );
  R(() => {
    f(m);
  }, [f, m.current]);
  const w = H(
    () => ({
      "--lines": n
    }),
    [n]
  );
  return /* @__PURE__ */ j(F, { className: g, children: [
    /* @__PURE__ */ a(
      G,
      {
        ref: m,
        "aria-expanded": !o || r,
        style: w,
        children: /* @__PURE__ */ a(
          A,
          {
            clickoutFunction: d,
            onImageLoad: () => f(m),
            children: y()
          }
        )
      }
    ),
    E && /* @__PURE__ */ a(N, { onClick: O, type: "button", children: c(o ? "retracted-content-read-more" : "retracted-content-read-less") }),
    x && /* @__PURE__ */ a(V, { "data-testid": "image-list", children: /* @__PURE__ */ a(P, { imagesContent: p }) })
  ] });
};
export {
  J as LINE_HEIGHT_AS_PIXELS,
  re as RetractedContent
};
